/**
 * TanStack Query hooks for `api-key-header-auth`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	apiKeyHeaderAuthQueryKeys,
	type CreateApiKeyHeaderAuthBody,
	type ListApiKeyHeaderAuthResponse,
	type ApiKeyHeaderAuthRow,
} from "./api";

export function useApiKeyHeaderAuthList(): UseQueryResult<ListApiKeyHeaderAuthResponse, Error> {
	return useQuery({
		queryKey: apiKeyHeaderAuthQueryKeys.list(),
		queryFn: list,
	});
}

export function useApiKeyHeaderAuthCreate(): UseMutationResult<ApiKeyHeaderAuthRow, Error, CreateApiKeyHeaderAuthBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apiKeyHeaderAuthQueryKeys.all });
		},
	});
}

export function useApiKeyHeaderAuthDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apiKeyHeaderAuthQueryKeys.all });
		},
	});
}
